import { render, staticRenderFns } from "./reset-password.page.vue?vue&type=template&id=38b74d24&scoped=true&"
import script from "./reset-password.page.vue?vue&type=script&lang=js&"
export * from "./reset-password.page.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.page.vue?vue&type=style&index=0&id=38b74d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b74d24",
  null
  
)

export default component.exports